<mat-select [formControl]="skjemakontroll()"
            [compareWith]="erValgt"
            panelClass="velg-medlem--alternativer"
            [placeholder]="placeholder()"
            panelWidth="300px"
            data-testid="velg-medlem-nedtrekksmeny">
  <mat-select-trigger>
    @if (skjemakontroll().value) {
      @switch (stil()) {
        @case ('kun-avatar') {
          <avatar stil="liten" [medlem]="skjemakontroll().value" skjulTooltip="true"/>
        }
        @default {
          <medlem-listevisning-kompakt [medlem]="skjemakontroll().value"/>
        }
      }
    } @else {
      {{'Ingen valgt'|translate}}
    }
  </mat-select-trigger>
  @for (gruppe of medlemmerGruppert(); track gruppe[0]?.id) {
    <mat-optgroup [label]="gruppe[0]?.tittel || ('uten rolle'|translate) ">
      @for (medlem of gruppe[1]; track medlem.id) {
        <mat-option [value]="medlem">
          <medlem-listevisning-kompakt [medlem]="medlem"/>
        </mat-option>
      }
    </mat-optgroup>
  }
  @if(tillatIngenValgt()){
    <mat-option class="mat-option--skillelinje-over"><span>{{'ingen'|translate}} </span></mat-option>
  }
</mat-select>
